import {useEffect, useState} from "react";
import { UseDebounceProps } from "./types";

function useDebounce({value, delay}: UseDebounceProps): string {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}

export {useDebounce}
